/**
 * PWA-UPDATE-1 — the one-line way for a screen to say "not right now".
 *
 * Usage, at the top of a screen that holds unsaved work:
 *
 *     useBusyClaim(status !== 'idle' && status !== 'done', 'bulk-import');
 *
 * The claim is released on unmount as well as when `active` goes false, so navigating away can never
 * strand a claim and block updates for the rest of the session.
 *
 * Keys are string literals, not generated per instance: two mounts of the same screen claiming the
 * same key is exactly the behaviour we want (the registry is a Set), and a generated key would make a
 * leaked claim impossible to recognise in `debugClaims()`.
 */
import { useEffect } from 'react';
import { claimBusy, releaseBusy } from './busyRegistry';

export function useBusyClaim(active: boolean, key: string): void {
  useEffect(() => {
    if (!active) return;
    claimBusy(key);
    return () => releaseBusy(key);
  }, [active, key]);
}

export default useBusyClaim;
